import React, { useCallback } from 'react';
import { RouteComponentProps } from 'react-router';

import useRouteQueryParams from 'core/hooks/useRouteQueryParams';
import useUserCreates from 'core/hooks/useUserCreates';
import { UserFormSchema } from 'core/schemas/userForm';
import { FormSubmitHandler } from 'Elements/Form';

import UserForm from './UserPage/UserForm';
import UserPage from './UserPage/UserPage';

export default function UserCreate({ history, location }: RouteComponentProps) {
  const create = useUserCreates();
  const { redirect, ...autofill } = useRouteQueryParams<
    UserFormSchema['user'] & { redirect: string }
  >(location);

  const onSubmit: FormSubmitHandler<UserFormSchema> = useCallback(
    (values, form) => {
      return create(values.user)
        .then(user => history.replace(redirect || `/users/${user.id}`))
        .catch(errors => form.setErrors({ user: errors }));
    },
    [create, history, redirect]
  );

  return (
    <UserForm onSubmit={onSubmit} user={autofill}>
      <UserPage title="Luo uusi käyttäjä" />
    </UserForm>
  );
}
